export enum UserRole {
  SalesRep = 'salesRep',
  Admin = 'admin',
  Dealer = 'dealer',
}
